var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRehireIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 9.139a4.4 4.4 0 0 1-7.362 1.973l-.249-.249h1.947a.6.6 0 0 0 0-1.2H3.19a.6.6 0 0 0-.6.6v3.394a.6.6 0 0 0 1.2 0v-1.945l.248.248a5.6 5.6 0 0 0 9.37-2.51.6.6 0 1 0-1.16-.311zm.983-2.978a.6.6 0 0 0 .176-.424V2.343a.6.6 0 0 0-1.2 0v1.945l-.248-.248a5.6 5.6 0 0 0-9.37 2.51.6.6 0 0 0 1.159.311 4.4 4.4 0 0 1 7.361-1.973l.25.249H9.414a.6.6 0 0 0 0 1.2h3.394a.6.6 0 0 0 .424-.176z",
    fill: "#150349"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRehireIcon);
export default __webpack_public_path__ + "static/media/rehire-icon.2c996dc6e437035e9be460e23c362e5f.svg";
export { ForwardRef as ReactComponent };